// extracted by mini-css-extract-plugin
export default {"gray-30":"rgb(193, 198, 205)","state":"styles_state__hueli","map":"styles_map__KXdgJ","title":"styles_title__N4y49","stateIcon":"styles_stateIcon__RnZxz"};